// libs
import * as React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { message, Upload } from 'antd';
import axios from 'axios';
// style
import '@style/component/upload/upload-qa.less';
import { FormattedMessage } from 'react-intl';
import { localizedString } from '@locale/index';

export interface UploadQAPropsInfo {
  success?: () => void;
  failed?: () => void;
}

export interface UploadQAStateInfo {
  loading: boolean;
  status: 'normal' | 'success' | 'fail';
}


export class UploadQA extends React.Component<
  UploadQAPropsInfo,
  UploadQAStateInfo
> {
  constructor(props: UploadQAPropsInfo) {
    super(props);

    this.state = {
      loading: false,
      status: 'normal'
    };
  }

  customUploadRequest = ({
    action,
    data,
    file,
    filename,
    onError,
    onSuccess
  }: any) => {
    const formData = new FormData();

    this.setState({
      loading: true
    });

    if (data) {
      Object.keys(data).map((key: string) => {
        formData.append(key, data[key]);
      });
    }
    formData.append('customKey', 'customValue');
    formData.append(filename, file);

    axios
      .post(action, formData)
      .then((res: any) => {
        const resData = res || {};
        this.setState({
          loading: false,
          status: 'success'
        });
        onSuccess(resData, file);
        if (this.props.success) {
          this.props.success();
        }
      })
      .catch((err: any) => {
        message.warning(err.message && err.message.length ? err.message : localizedString('intent_batch_create_failed'));

        this.setState({
          loading: false,
          status: 'fail'
        });
        onError(err);
        if (this.props.failed) {
          this.props.failed();
        }
      });
  };

  render() {
    const { loading, status } = this.state;

    return (
      <div className="upload-qa__Wrap">
        <Upload
          accept=".txt"
          action={`/dialogflow/intent/batch/doc`}
          name="file"
          customRequest={this.customUploadRequest}
          fileList={[]}
        >
          <span className="upload-trigger__Span">
            <FormattedMessage id="common_upload_file" />
            {loading ? (
              <LoadingOutlined
                style={{
                  marginLeft: 14
                }} />
            ) : (
              ''
            )}
          </span>
        </Upload>
        <span
          className={`upload-status ${status === 'success' ? 'success' : ''} ${status === 'fail' ? 'fail' : ''
            }`}
        >
          {status !== 'normal'
            ? status === 'success'
              ? localizedString('common_upload_success')
              : localizedString('common_upload_failed')
            : ''}
        </span>
      </div>
    );
  }
}
